<template>
	<VDropdown>
		<div class="flex cursor-pointer items-center justify-center">
			<slot />
		</div>

		<template #popper="{ hide }">
			<div class="bg-[white]">
				<div
					v-for="option of options"
					:key="option.value"
					class="pointer hover:won-tag-light-gray flex h-6 items-center px-2.5 hover:bg-won-bg-blue"
					:class="option?.disabled ? 'cursor-not-allowed! opacity-50' : 'cursor-pointer'"
					@click="handleSelect(option, hide)"
				>
					<component
						:is="option.icon"
						class="size-3 text-won-blue"
					/>
					<div :class="['won-blue ml-1 text-xs', itemClass]">
						{{ option.label }}
					</div>
				</div>
			</div>
		</template>
	</VDropdown>
</template>

<script setup>
defineProps({
	options: {
		type: Array,
		default: () => [],
	},
	itemClass: {
		type: String,
		default: '',
	},
});

const emit = defineEmits(['menu-dropdown:select']);

const handleSelect = (option, hide) => {
	emit('menu-dropdown:select', option);
	hide?.();
};
</script>
